const BASE_URL = "https://curator.mrc.ai/api";

export async function getSources() {
  const response = await fetch(`${BASE_URL}/sources`);
  if (!response.ok) throw new Error("Failed to fetch Sources");
  return await response.json();
}

export async function getSource(sourceId) {
  const response = await fetch(`${BASE_URL}/sources/${sourceId}`);
  if (!response.ok) throw new Error("Failed to fetch Source");
  return await response.json();
}

export async function createSource(source) {
  const response = await fetch(`${BASE_URL}/sources`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(source),
  });
  if (!response.ok) throw new Error("Failed to create Source");
  return await response.json();
}

export async function updateSource(sourceId, source) {
  const response = await fetch(`${BASE_URL}/sources/${sourceId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(source),
  });
  if (!response.ok) throw new Error("Failed to update Source");
  return await response.json();
}
